/**
 * Normalise une chaîne pour la recherche : minuscules, sans accents.
 * "Mélanie" → "melanie", "JOËL" → "joel".
 */
export function normalizeForSearch(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();
}

/**
 * Vrai si la requête est le début d'un des mots du nom, accents ignorés :
 * "mel" trouve "Mélanie", "dup" trouve "Marie Dupont", "marc" trouve "Jean-Marc".
 * Une requête vide accepte tout le monde.
 */
export function matchesNamePrefix(name: string, query: string): boolean {
  const q = normalizeForSearch(query);
  if (!q) return true;
  const normalized = normalizeForSearch(name);
  if (normalized.startsWith(q)) return true;
  return normalized.split(/[\s'’\-_.]+/).some((word) => word.startsWith(q));
}

/** Recherche « contient », accents et casse ignorés : "melanie" trouve "Mélanie". */
export function includesNormalized(haystack: string, needle: string): boolean {
  const q = normalizeForSearch(needle);
  if (!q) return true;
  return normalizeForSearch(haystack).includes(q);
}
